import CityBreak from './city_break';
import CityLife from './city_life';
import CottageWeekend from './cottage_weekend';
import Default from './default';
import Entertainment from './entertainment';
import Finance from './finance';
import ForestWeekend from './forest_weekend';
import LakeWeekend from './lake_weekend';
import Nature from './nature';
import Social from './social';
import SummerHoliday from './summer_holiday';
import Technology from './technology';
import Travel from './travel';
import WinterHoliday from './winter_holiday';
import Work from './work';

export const PROFILE_PLACES = {
  CityBreak,
  CityLife,
  CottageWeekend,
  Default,
  Entertainment,
  Finance,
  ForestWeekend,
  LakeWeekend,
  Nature,
  Social,
  SummerHoliday,
  Technology,
  Travel,
  WinterHoliday,
  Work,
};
